import { render, staticRenderFns } from "./ProjectSettingsParentBar.component.vue?vue&type=template&id=50afc9d6&scoped=true"
import script from "./ProjectSettingsParentBar.component.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsParentBar.component.vue?vue&type=style&index=0&id=50afc9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afc9d6",
  null
  
)

export default component.exports